import React from 'react';

import { Box, Container, Typography } from '@mui/material';
import cx from 'classnames';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

import PlayLargeIcon from '../../../../assets/icons/PlaySmallIcon';
import IKImage from '../../../../components/IKImage/IKImage';
import { CategoryLabel } from '../../../../components/UI/CategoryLabel';
import DifficultyIcon from '../../../../components/UI/DifficultyIcon';
import { Video } from '../../../../types';
import { createCategoryLink } from '../../../../utils/helpers';
import { DEFAULT_URL } from '../../../DiscoverPage/const';
import { PAYWALLED_CONTENT_SELECTORS } from '../../const';
import useStyles from '../../styles';

interface LoggedOutHeaderProps {
  video: Video;
  handleOpenJoinModal: () => void;
}

const LoggedOutHeader: React.FC<LoggedOutHeaderProps> = ({ video, handleOpenJoinModal }) => {
  const classes = useStyles(false)();

  return (
    <>
      <Box className={classes.headerWrapper} data-testid="loggedOutHeader">
        <Container>
          <Box className={classes.textWrapper}>
            {video.title && (
              <Typography variant="h1" className={classes.title} data-testid="videoTitle">
                {video.title}
              </Typography>
            )}
            <Box className={classes.authorBlock}>
              {video.user?.avatar && (
                <IKImage
                  className={classes.avatar}
                  path={video.user.avatar}
                  alt={video.user.name}
                  srcset={[{ width: 40, height: 40, crop: 'maintain_ratio', focus: 'auto' }]}
                  sizes="40px"
                  draggable={false}
                  data-testid="expertImage"
                />
              )}
              {video.user?.name && video?.user?.slug ? (
                <Link to={`${DEFAULT_URL}/experts/${video?.user?.slug}`} data-testid="expertLink">
                  <Typography variant="h3" className={classes.author}>
                    {video.user.name}
                  </Typography>
                </Link>
              ) : (
                <Typography variant="h3" className={classes.author}>
                  {video?.user?.name}
                </Typography>
              )}
            </Box>
            {video.description && (
              <Box data-testid="videoDescription" className={classes.description}>
                {parse(video.description)}
              </Box>
            )}
            <Box
              className={cx(classes.playBtn, PAYWALLED_CONTENT_SELECTORS.VIDEO_PLAY_BTN_SMALL)}
              onClick={handleOpenJoinModal}
              data-testid="playBtn"
            >
              <PlayLargeIcon fontSize="large" className={classes.playBtnIcon} />
            </Box>
          </Box>
          {video.categories && video.categories.length > 0 && (
            <Box className={classes.categoriesWrapper}>
              {video.categories.map((category) => {
                const categoryLink = createCategoryLink(category);
                return (
                  category && (
                    <CategoryLabel
                      key={category.id}
                      name={category?.title}
                      url={categoryLink}
                      withDots={false}
                      data-testid="categoryChips"
                    />
                  )
                );
              })}
              {video?.difficulty && (
                <DifficultyIcon difficulty={video?.difficulty} data-testid="videoDifficultyIcon" />
              )}
            </Box>
          )}
          <Box
            className={cx(classes.playBtnDesktop, PAYWALLED_CONTENT_SELECTORS.VIDEO_PLAY_BTN)}
            onClick={handleOpenJoinModal}
          >
            <PlayLargeIcon fontSize="large" className={classes.playBtnDesktopIcon} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default LoggedOutHeader;
